define((require) => {
    "use strict";

    const {ItemView}                = require("marionette");
    const template                  = require("editor/ui/settings/fonts/CustomFontItemView.tpl");
    const Permissions               = require("shared/security/Permissions");
    const Tooltip                   = require("ui/common/Tooltip");
    const EditorEvents              = require("shared/services/EditorEvents");
    const EditorWebFontController   = require("editor/ui/experience/editor/EditorWebFontController");
    const FontProvider              = require("shared/data/fonts/FontProvider");

    // We need to preserve the same `className` for both item views for the collection view
    // ordering to work correctly, see zbone/CollectionView.
    const ITEM_VIEW_CLASS_NAME = "custom-font-item-view";

    /**
     * The default item view representing font family and format.
     *
     * @class CustomFontItemView
     */
    return ItemView.extend("CustomFontItemView", {

        tagName: "li",

        className: ITEM_VIEW_CLASS_NAME,

        template,

        ui: {
            deleteIcon: ".delete-icon"
        },

        events: {
            "click @ui.deleteIcon":  "_deleteFontClickHandler"
        },

        onShow() {
            let tooltipContent = "Delete font.";

            if (Permissions.Roles.MANAGER.cannot()) {
                tooltipContent = "You do not have permission to delete this font.";
            } else if (this.model.get("timesUsed")) {
                tooltipContent = "This font cannot be deleted because it is in use.";
            }

            Tooltip.add(this.ui.deleteIcon, {
                content: tooltipContent,
                placement: "top"
            });
        },

        _deleteFontClickHandler() {
            if (!this.model.get("readOnly") && confirm("Are you sure you want to delete this font?")) {
                Tooltip.remove(this.ui.deleteIcon);
                this.model
                    .destroy()
                    .then(() => {
                        EditorWebFontController.unregister(this.model, FontProvider.CUSTOM);

                        const eventProperties = {
                            fontId: this.model.get("id"),
                            fontName: this.model.get("name"),
                            fontType: "custom",
                            triggerOrigin: "CustomFontDeleteIcon"
                        };

                        EditorEvents.trigger(EditorEvents.constants.DELETE_FONT, eventProperties);
                    });
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/fonts/CustomFontItemView.js